import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @Input() event: any = {};
  @Input() summary: any = {};

  @Output() changeStatus: EventEmitter<any> = new EventEmitter();
  destroyRef = inject(DestroyRef)
  public form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    console.log('Overriden Version of JS');
    
    this.form = this.formBuilder.group({
      'status': 1
    });

    this.form.get('status').valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((value) => {
      this.changeStatus.emit(value);
    })
  }
}
